
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/hifi",
      function () {
        return require("private-next-pages/features/hifi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/hifi"])
      });
    }
  